import { useEffect } from 'react';
import PulsingLogo from 'components/spinner';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { buildIdAppUrl } from 'helpers/cookieUtils';
import { redeemInvite } from 'api/authApi';
import { useAuth } from 'context/auth-context';

type LoginParams = { token: string };

function Login() {
  const { token } = useParams<keyof LoginParams>();
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleAuth = async () => {
      // If there's a token in the URL, redeem it first
      if (token) {
        try {
          await redeemInvite(token);
        } catch (error) {
          // Token redemption failed, continue to redirect anyway
          // eslint-disable-next-line no-console
          console.error('Token redemption failed:', error);
        }
      }

      // If user is already authenticated, navigate to the app
      if (user) {
        const from = (location.state as any)?.from || '/';
        navigate(from, { replace: true });
      } else {
        // Redirect to ID app with return URL
        // Extract pathname from location object if needed
        const fromState = (location.state as any)?.from;
        const fromPath = fromState?.pathname
          ? `${fromState.pathname}${fromState.search || ''}`
          : '/';
        const returnUrl = `${window.location.origin}${fromPath}`;
        window.location.href = buildIdAppUrl(returnUrl);
      }
    };

    handleAuth();
  }, [user, token, navigate, location]);

  return <PulsingLogo overlay />;
}

export default Login;
